import React, { useEffect, useMemo, useRef, useState } from "react";
import "./DeviceListModal.css";
import { useLanguage } from "../i18n/LanguageContext";

/* ── Device catalog with sub-categories ── */
const BRAND_DATA = [
    {
        brand: "Apple",
        subsections: [
            {
                label: "IPHONE SERIES",
                models: [
                    "iPhone 17 Pro Max", "iPhone 17 Pro", "iPhone 17 Air", "iPhone 17",
                    "iPhone 16e", "iPhone 16 Pro Max", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16",
                    "iPhone 15 Pro Max", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15",
                    "iPhone 14 Pro Max", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14",
                    "iPhone SE 3 (2022)",
                    "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13 Mini", "iPhone 13",
                    "iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12 Mini", "iPhone 12",
                    "iPhone SE 2 (2020)",
                    "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11",
                    "iPhone XS Max", "iPhone XS", "iPhone XR",
                ],
            },
            {
                label: "IPAD CELLULAR",
                models: [
                    "iPad Pro 11-inch (1st gen ke atas)",
                    "iPad Pro 12.9-inch (3rd gen ke atas)",
                    "iPad Air (3rd gen ke atas)",
                    "iPad (7th gen ke atas)",
                    "iPad Mini (5th gen ke atas)",
                ],
            },
        ],
    },
    {
        brand: "Samsung",
        subsections: [
            {
                label: "S SERIES",
                models: [
                    "Galaxy S25 Ultra", "Galaxy S25+", "Galaxy S25 Edge", "Galaxy S25 Slim", "Galaxy S25",
                    "Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24 FE", "Galaxy S24",
                    "Galaxy S23 Ultra", "Galaxy S23+", "Galaxy S23 FE", "Galaxy S23",
                    "Galaxy S22 Ultra", "Galaxy S22+", "Galaxy S22",
                    "Galaxy S21+ Ultra 5G", "Galaxy S21+ 5G", "Galaxy S21",
                    "Galaxy S20 Ultra", "Galaxy S20+", "Galaxy S20",
                ],
            },
            {
                label: "Z SERIES (FOLDABLE)",
                models: [
                    "Galaxy Z Fold7", "Galaxy Z Fold6", "Galaxy Z Fold5",
                    "Galaxy Z Fold4", "Galaxy Z Fold3 5G", "Galaxy Z Fold2 5G", "Galaxy Fold",
                    "Galaxy Z Flip 7 FE", "Galaxy Z Flip 7", "Galaxy Z Flip6",
                    "Galaxy Z Flip5", "Galaxy Z Flip4", "Galaxy Z Flip3 5G", "Galaxy Z Flip",
                ],
            },
            {
                label: "A & NOTE SERIES",
                models: [
                    "Galaxy XCover7 Pro",
                    "Galaxy A56", "Galaxy A55 5G", "Galaxy A54 5G",
                    "Galaxy A36", "Galaxy A35 5G", "Galaxy A23 5G",
                    "Galaxy Note 20 Ultra 5G", "Galaxy Note 20",
                ],
            },
        ],
    },
    {
        brand: "Google Pixel",
        subsections: [
            {
                label: "PIXEL SERIES",
                models: [
                    "Pixel 10 Pro Fold", "Pixel 10 Pro XL", "Pixel 10 Pro", "Pixel 10",
                    "Pixel 9 Pro Fold", "Pixel 9 Pro XL", "Pixel 9 Pro", "Pixel 9", "Pixel 9a",
                    "Pixel Fold",
                    "Pixel 8 Pro", "Pixel 8", "Pixel 8a",
                    "Pixel 7 Pro", "Pixel 7", "Pixel 7a",
                    "Pixel 6 Pro", "Pixel 6a", "Pixel 6",
                    "Pixel 5a", "Pixel 5",
                    "Pixel 4 XL", "Pixel 4a", "Pixel 4",
                    "Pixel 3a XL", "Pixel 3a",
                    "Pixel 3 XL", "Pixel 3",
                    "Pixel 2 XL", "Pixel 2",
                ],
            },
        ],
    },
    {
        brand: "Xiaomi",
        subsections: [
            {
                label: "XIAOMI & REDMI SERIES",
                models: [
                    "Xiaomi 15 Ultra", "Xiaomi 15",
                    "Xiaomi 14T Pro", "Xiaomi 14T", "Xiaomi 14 Pro", "Xiaomi 14",
                    "Xiaomi 13T Pro", "Xiaomi 13T", "Xiaomi 13 Pro", "Xiaomi 13 Lite", "Xiaomi 13",
                    "Xiaomi 12T Pro",
                    "Poco X7",
                    "Redmi Note 14 Pro+ 5G", "Redmi Note 14 Pro 5G", "Redmi Note 14 Pro",
                    "Redmi Note 13 Pro+", "Redmi Note 13 Pro",
                    "Redmi Note 11 Pro 5G",
                ],
            },
        ],
    },
];

const OTHER_BRANDS = [
    {
        label: "OPPO",
        models: [
            "Oppo Find X8 Pro", "Oppo Find X8", "Oppo Reno14 Pro", "Oppo Reno14",
            "Oppo Find N3", "Oppo Find N3 Flip", "Oppo Find X5 Pro", "Oppo Find X5",
            "Oppo A55s 5G", "Oppo Reno 9A", "Oppo Find N2 Flip", "Oppo Find X3 Pro", "Oppo Reno 5A",
        ],
    },
    {
        label: "MOTOROLA",
        models: [
            "Motorola Edge 60 Pro", "Motorola Edge 60",
            "Motorola Edge 50 Ultra", "Motorola Edge 50 Pro", "Motorola Edge 50",
            "Motorola Edge 40 Pro", "Motorola Edge 40",
            "Motorola Razr 60", "Motorola Razr 50 Ultra", "Motorola Razr 50",
            "Motorola Razr 40 Ultra", "Motorola Razr 40",
            "Motorola ThinkPhone 25",
        ],
    },
    {
        label: "SONY",
        models: [
            "Sony Xperia 1 VII", "Sony Xperia 1 VI", "Sony Xperia 1 V", "Sony Xperia 1 IV",
            "Sony Xperia 5 V", "Sony Xperia 5 IV",
            "Sony Xperia 10 VI", "Sony Xperia 10 V", "Sony Xperia 10 IV",
            "Sony Xperia Ace III", "Sony Xperia 10 III Lite",
        ],
    },
    {
        label: "OTHERS",
        models: [
            "Honor Magic V3", "Honor 200 Pro", "Honor Magic 6 Pro", "Honor Magic V2", "Honor Magic 5 Pro",
            "Vivo X200 Pro", "Vivo X200", "Vivo V50", "Vivo V40",
            "OnePlus 13", "OnePlus 12", "OnePlus 11", "OnePlus Open",
            "Huawei Mate 40 Pro", "Huawei P40 Pro", "Huawei P40",
            "Sharp AQUOS R8 Pro", "Sharp AQUOS R8", "Sharp AQUOS sense8",
        ],
    },
];

// "all" is a sentinel shown as devices.all; the brand names never translate.
const BRAND_TABS = ["all", "Apple", "Samsung", "Google", "Xiaomi"];

const norm = (s) => s.toLowerCase().trim();

const DeviceListModal = ({ onClose }) => {
    const [query, setQuery]           = useState("");
    const [activeBrand, setActiveBrand] = useState("all");
    const { t } = useLanguage();
    const searchRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => { searchRef.current?.focus(); }, []);

    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") { e.preventDefault(); onClose?.(); } };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    useEffect(() => { contentRef.current?.scrollTo({ top: 0 }); }, [query, activeBrand]);

    const q = norm(query);
    const matchModel = (model) => !q || norm(model).includes(q);

    const visibleBrands = useMemo(() => {
        if (activeBrand === "all") return BRAND_DATA;
        return BRAND_DATA.filter(({ brand }) => norm(brand).includes(norm(activeBrand)));
    }, [activeBrand]);

    const showOthers = activeBrand === "all";

    const othersHaveResults = OTHER_BRANDS.some(({ models }) => models.some(matchModel));

    const noResults = useMemo(() => {
        const brandsEmpty = visibleBrands.every(({ subsections }) =>
            subsections.every(({ models }) => models.filter(matchModel).length === 0)
        );
        return q && brandsEmpty && (!showOthers || !othersHaveResults);
    }, [q, visibleBrands, showOthers, othersHaveResults]);

    return (
        <div className="dlm-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label={t("devices.dialogAria")}>
            <div className="dlm-modal" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="dlm-header">
                    <button className="dlm-back-btn" onClick={onClose} aria-label={t("common.back")}>
                        <img src={`${process.env.PUBLIC_URL}/icons/arrow-left.svg`} width={16} height={16} alt="" />
                    </button>
                    <div className="dlm-title-block">
                        <h2 className="dlm-title">{t("devices.title")}</h2>
                        <p className="dlm-version">{t("devices.version")}</p>
                    </div>
                </div>

                {/* ── Search ── */}
                <div className="dlm-search-wrap">
                    <div className="dlm-search">
                        <svg className="dlm-search-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M15.5 14h-.79l-.28-.27a6.471 6.471 0 001.48-4.23C15.91 6.01 13.4 3.5 10.41 3.5S4.91 6.01 4.91 9s2.51 5.5 5.5 5.5c1.61 0 3.09-.59 4.23-1.48l.27.28v.79l4.25 4.25 1.27-1.27L15.5 14zm-5.09 0C8.02 14 6 11.98 6 9.5S8.02 5 10.41 5s4.41 2.02 4.41 4.5S12.8 14 10.41 14z" />
                        </svg>
                        <input
                            ref={searchRef}
                            className="dlm-search-input"
                            type="text"
                            placeholder={t("devices.searchPlaceholder")}
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            aria-label={t("devices.searchAria")}
                        />
                        {query && (
                            <button className="dlm-search-clear" aria-label={t("devices.clearSearch")} onClick={() => setQuery("")}>✕</button>
                        )}
                    </div>
                </div>

                {/* ── Brand filter tabs ── */}
                <div className="dlm-tabs-wrap">
                    <div className="dlm-tabs">
                        {BRAND_TABS.map((tab) => (
                            <button
                                key={tab}
                                className={`dlm-tab ${activeBrand === tab ? "active" : ""}`}
                                onClick={() => setActiveBrand(tab)}
                            >
                                {tab === "all" ? t("devices.all") : tab}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ── Content ── */}
                <div className="dlm-content" ref={contentRef}>

                    {/* Main brand sections */}
                    {visibleBrands.map(({ brand, subsections }) => {
                        const totalCount = subsections.reduce((a, s) => a + s.models.length, 0);
                        const hasAnyMatch = subsections.some(({ models }) => models.some(matchModel));
                        if (q && !hasAnyMatch) return null;
                        return (
                            <div key={brand} className="dlm-brand-section">
                                <div className="dlm-brand-header">
                                    <span className="dlm-brand-name">{brand}</span>
                                    <span className="dlm-brand-badge">{t("devices.models", { n: totalCount })}</span>
                                </div>

                                {subsections.map(({ label, models }) => {
                                    const shown = q ? models.filter(matchModel) : models;
                                    if (shown.length === 0) return null;
                                    return (
                                        <div key={label} className="dlm-subsection">
                                            <p className="dlm-subsection-label">{label}</p>
                                            <div className="dlm-device-grid">
                                                {shown.map((model) => (
                                                    <span key={model} className={`dlm-device-item${q && norm(model).includes(q) ? " match" : ""}`}>
                                                        {model}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}

                    {/* Other Manufacturers */}
                    {showOthers && (!q || othersHaveResults) && (
                        <div className="dlm-brand-section">
                            <div className="dlm-brand-header">
                                <span className="dlm-brand-name">{t("devices.others")}</span>
                            </div>
                            <div className="dlm-others-grid">
                                {OTHER_BRANDS.map(({ label, models }) => {
                                    const shown = q ? models.filter(matchModel) : models;
                                    if (shown.length === 0) return null;
                                    return (
                                        <div key={label} className="dlm-others-col">
                                            <p className="dlm-subsection-label">{label}</p>
                                            {shown.map((model) => (
                                                <span key={model} className={`dlm-device-item${q && norm(model).includes(q) ? " match" : ""}`}>
                                                    {model}
                                                </span>
                                            ))}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Empty state */}
                    {noResults && (
                        <div className="dlm-empty-state">
                            <p className="dlm-empty-title">{t("devices.emptyTitle")}</p>
                            <p className="dlm-empty-desc">{t("devices.emptyDesc", { query })}</p>
                            <button className="dlm-reset-btn" onClick={() => setQuery("")}>{t("devices.reset")}</button>
                        </div>
                    )}

                    {/* Bottom note */}
                    <div className="dlm-note">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" style={{ flexShrink: 0, marginTop: 1 }}>
                            <circle cx="7" cy="7" r="6.5" stroke="#096dd9" strokeWidth="1" />
                            <path d="M7 6v4" stroke="#096dd9" strokeWidth="1.5" strokeLinecap="round" />
                            <circle cx="7" cy="4.5" r="0.75" fill="#096dd9" />
                        </svg>
                        <div className="dlm-note-body">
                            <p className="dlm-note-title">{t("devices.noteTitle")}</p>
                            <p className="dlm-note-desc">{t("devices.noteDesc")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceListModal;
